import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-rejectpayment',
  templateUrl: './rejectpayment.component.html',
  styleUrls: ['./rejectpayment.component.css']
})
export class RejectpaymentComponent {
  form: FormGroup;
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<RejectpaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { paymentId: number }
  ) {
    this.form = this.fb.group({
      note: ['', Validators.required]
    });
  }
  submit() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value.note);
    }
  }
}
